
export const validation = function (value, lbl) {
    const validationInfo = {
        isError: false,
        helperText: ""
    }

    switch (lbl) {
        case "השם שלך":
        case "שם המשפחה שלך":
            if (/^\s|\s$/.test(value)) {
                validationInfo.isError = true;
                validationInfo.helperText = "כדאי לבדוק שאין רווח מיותר";
              } else if (/\d/.test(value) || /[^\u0590-\u05FF\s\w]/.test(value)) {
                validationInfo.isError = true;
                validationInfo.helperText = "רק לרובוטים יש ספרות בשם";
              } else if (!new RegExp(/^[\p{L}\s]{2,}$/u).test(value)) {
                validationInfo.isError = true;
                validationInfo.helperText = "המינימום לשם הוא 2 אותיות";
              }
            break;
        case "הטלפון הנייד שלך":
            // The regular expression to match an Israeli mobile phone number starting with "05" and followed by 8 digits.
            if (!new RegExp(/^05\d{8}$/).test(value)) {
                validationInfo.isError = true;
                validationInfo.helperText = "במספר טלפון תקין יש 10 ספרות";
            }
            break;

        case "מייל":
        case "מייל שכחתי סיסמה":
            // The regular expression to validate an email address.
            if (!new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/).test(value)) {
                validationInfo.isError = true;
                validationInfo.helperText = "hopa@lupa.co.il הנה דוגמה למבנה מייל תקין";
            }
            break;
        case "הסיסמה שלך":
            if (!new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$").test(value)) {
                validationInfo.isError = true;
                validationInfo.helperText = `
                מינימום 8 תווים, 
                אות גדולה ואות קטנה,
                מספר וסימן מיוחד`;
            }
            break;
    }
    return validationInfo;
};
